import React from 'react'
import type { ReactNode } from 'react'
import { Flex, Stack, Text } from '@mantine/core'
import { IconCircleCheck } from '@tabler/icons-react'
import type { TagRenderers } from '@/lib/parseHtml'

interface BulletTextProps {
    c?: string
    fz?: number
    lh?: string
}

export function createBulletRenderers(textProps?: BulletTextProps): TagRenderers {
    const {
        c = 'var(--Foreground-fg-primary, #1F1E1D)',
        fz = 16,
        lh = '125%',
    } = textProps ?? {}

    return {
        ul: (children, key) => (
            <Stack key={key} gap={12}>
                {children}
            </Stack>
        ),
        li: (children, key) => (
            <Flex key={key} align="flex-start" gap={8} style={{ alignSelf: 'stretch' }}>
                <IconCircleCheck
                    size={20}
                    color="#087442"
                    stroke={2}
                    style={{ flexShrink: 0, marginTop: 2 }}
                />
                <Text c={c} fz={fz} lh={lh}>
                    {children}
                </Text>
            </Flex>
        ),
    }
}
